import {
  tabCloser,
  tabIcons,
  tabTemplate,
  categoryCodeTab,
} from '@/layout/state/state';
import { matchCodeUrl } from '@/constants/urls';
import CollectionActions from '../containers/CollectionActions';
import { closeCollection } from '../actions';
import CollectionPanel from '../components/CollectionPanel';

export default (urls, access) => ({
  ...tabTemplate('collection', CollectionPanel, matchCodeUrl(urls), CollectionActions),
  ...tabCloser('closeCollectionTab', closeCollection),
  ...tabIcons('object group', 'far fa-'),
  access,
  order: 305,
  position: 'left',
  componentState: ({ args, url }) => categoryCodeTab(url, args[2]),
});
